// Fire Service Icon Set — Custom SVG icons for fire inspection domain
// To add new icons: create a new .tsx file in this folder, then add it to the
// FIRE_SERVICE_ICONS array below. The IconPicker will pick it up automatically.

export { default as FireHydrant } from './FireHydrant';
export { default as FireExtinguisher } from './FireExtinguisher';
export { default as HoseNozzle } from './HoseNozzle';
export { default as MalteseCross } from './MalteseCross';
export { default as NfpaDiamond } from './NfpaDiamond';
export { default as LadderTruck } from './LadderTruck';
export { default as FireEngine } from './FireEngine';
export { default as Ambulance } from './Ambulance';
export { default as SmokeDetector } from './SmokeDetector';
export { default as SprinklerHead } from './SprinklerHead';
export { default as FireAlarmPull } from './FireAlarmPull';
export { default as ExitSign } from './ExitSign';
export { default as HazmatPlacard } from './HazmatPlacard';
export { default as InspectionBadge } from './InspectionBadge';
export { default as DeficiencyFlag } from './DeficiencyFlag';
export { default as HighRise } from './HighRise';
export { default as Aed } from './Aed';

export type { FireIconProps } from './types';

// ── Registry ────────────────────────────────────────────────────────
// Each entry maps a kebab-case name → { Component, label }.
// The IconPicker uses this to merge fire-service icons into its list.

import type { ComponentType } from 'react';
import FireHydrant from './FireHydrant';
import FireExtinguisher from './FireExtinguisher';
import HoseNozzle from './HoseNozzle';
import MalteseCross from './MalteseCross';
import NfpaDiamond from './NfpaDiamond';
import LadderTruck from './LadderTruck';
import FireEngine from './FireEngine';
import Ambulance from './Ambulance';
import SmokeDetector from './SmokeDetector';
import SprinklerHead from './SprinklerHead';
import FireAlarmPull from './FireAlarmPull';
import ExitSign from './ExitSign';
import HazmatPlacard from './HazmatPlacard';
import InspectionBadge from './InspectionBadge';
import DeficiencyFlag from './DeficiencyFlag';
import HighRise from './HighRise';
import Aed from './Aed';

export interface FireServiceIconEntry {
  kebab: string;
  pascal: string;
  label: string;
  Component: ComponentType<{ size?: number | string; className?: string; style?: React.CSSProperties }>;
}

export const FIRE_SERVICE_ICONS: FireServiceIconEntry[] = [
  { kebab: 'fs-fire-hydrant',      pascal: 'FsFireHydrant',      label: 'Fire Hydrant',      Component: FireHydrant },
  { kebab: 'fs-fire-extinguisher', pascal: 'FsFireExtinguisher', label: 'Fire Extinguisher', Component: FireExtinguisher },
  { kebab: 'fs-hose-nozzle',       pascal: 'FsHoseNozzle',       label: 'Hose Nozzle',       Component: HoseNozzle },
  { kebab: 'fs-maltese-cross',     pascal: 'FsMalteseCross',     label: 'Maltese Cross',     Component: MalteseCross },
  { kebab: 'fs-nfpa-diamond',      pascal: 'FsNfpaDiamond',      label: 'NFPA Diamond',      Component: NfpaDiamond },
  { kebab: 'fs-ladder-truck',      pascal: 'FsLadderTruck',      label: 'Ladder Truck',      Component: LadderTruck },
  { kebab: 'fs-fire-engine',       pascal: 'FsFireEngine',       label: 'Fire Engine',       Component: FireEngine },
  { kebab: 'fs-ambulance',         pascal: 'FsAmbulance',        label: 'Ambulance',         Component: Ambulance },
  { kebab: 'fs-smoke-detector',    pascal: 'FsSmokeDetector',    label: 'Smoke Detector',    Component: SmokeDetector },
  { kebab: 'fs-sprinkler-head',    pascal: 'FsSprinklerHead',    label: 'Sprinkler Head',    Component: SprinklerHead },
  { kebab: 'fs-fire-alarm-pull',   pascal: 'FsFireAlarmPull',    label: 'Fire Alarm Pull',   Component: FireAlarmPull },
  { kebab: 'fs-exit-sign',         pascal: 'FsExitSign',         label: 'Exit Sign',         Component: ExitSign },
  { kebab: 'fs-hazmat-placard',    pascal: 'FsHazmatPlacard',    label: 'Hazmat Placard',    Component: HazmatPlacard },
  { kebab: 'fs-inspection-badge',  pascal: 'FsInspectionBadge',  label: 'Inspection Badge',  Component: InspectionBadge },
  { kebab: 'fs-deficiency-flag',   pascal: 'FsDeficiencyFlag',   label: 'Deficiency Flag',   Component: DeficiencyFlag },
  { kebab: 'fs-high-rise',         pascal: 'FsHighRise',         label: 'High Rise',         Component: HighRise },
  { kebab: 'fs-aed',               pascal: 'FsAed',              label: 'AED',               Component: Aed },
];
